import { FileDto } from "@/lib/gen-api";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDropbox,
  faGoogleDrive,
  faMicrosoft,
} from "@nnr/fontawesome-classic-brands/icons/classic/brands";
import { faCloud } from "@nnr/fontawesome-sharp-light/icons/sharp/light";

type ExternalProvider = FileDto["externalProvider"];
type NoUndefined<T> = T extends null | undefined ? never : T;
type FileExternalProvider = Exclude<NoUndefined<ExternalProvider>, "FIREFLIES">;

type ExternalFileProviderDisplayNameProps = {
  externalProvider: ExternalProvider;
};

const PROVIDER_ICONS_MAP: Record<FileExternalProvider, IconDefinition> = {
  GOOGLE_DRIVE: faGoogleDrive,
  DROPBOX: faDropbox,
  ONEDRIVE: faCloud,
  SHAREPOINT: faMicrosoft,
};

function providerIcon(
  externalProvider: NonNullable<ExternalProvider>,
): IconDefinition {
  if (externalProvider === "FIREFLIES") {
    return faCloud;
  }

  return PROVIDER_ICONS_MAP[externalProvider];
}

export const ExternalFileProviderIcon = (
  props: ExternalFileProviderDisplayNameProps,
) => {
  if (props.externalProvider === null) {
    return null;
  }

  const icon = providerIcon(props.externalProvider);

  return <FontAwesomeIcon icon={icon} />;
};
